import { AuthenticatorFormFields } from './AuthenticatorFormFields';
import { AuthenticatorComponent } from './AuthenticatorComponent';
import {
    ConfirmSignInInput,
    ConfirmSignInOutput,
    SignInOutput,
    confirmSignIn,
    signIn,
} from 'aws-amplify/auth';
import { AuthenticatorProps } from '@aws-amplify/ui-react';

function redirectToEmail(signInResult: SignInOutput): SignInOutput {
    if (
        signInResult.nextStep.signInStep ===
        'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE'
    ) {
        return {
            isSignedIn: false,
            nextStep: {
                signInStep: 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
            },
        };
    }
    return signInResult;
}

export const authenticatorSettings = {
    services: {
        // サインイン時の処理
        async handleSignIn({ username, password, options }) {
            try {
                const signInResult = await signIn({
                    username,
                    password,
                    options: {
                        ...options,
                        authFlowType: 'CUSTOM_WITH_SRP',
                        preferredChallenge: 'EMAIL_OTP',
                    },
                });
                return redirectToEmail(signInResult);
            } catch (error) {
                console.log({ error });
                throw error;
            }
        },

        // @ts-ignore
        async handleForceChangePassword(input: ConfirmSignInInput) {
            const result = await confirmSignIn(input);
            return redirectToEmail(result);
        },

        // mfa認証時の処理
        async handleConfirmSignIn({
            challengeResponse,
        }): Promise<ConfirmSignInOutput> {
            let signInResult = await confirmSignIn({
                challengeResponse,
            });
            if (!signInResult.isSignedIn) {
                throw new Error(
                    '認証コードが間違っています。もう一度正確な認証コードを入力してください。認証コードを再送信しました。お手数ですが、受信ボックスを確認してください。'
                );
            }
            return redirectToEmail(signInResult);
        },
    },
    formFields: AuthenticatorFormFields,
    components: AuthenticatorComponent,
    hideSignUp: true,
} as const satisfies AuthenticatorProps;
